<template>
  <ReportWrapper>
    <template #actions>
      <CustomerAutocomplete
        v-model="selectedCustomer"
        class="w-2/6 x-sm:w-full"
        label=""
        placeholder="Customer"
        customer
        hide-details
        :return-object="true"
        item-value="accountNumber"
      />
      <CfsDropdown
        icon="mdi-tray-arrow-down"
        medium
        :disabled="!selectedCustomer"
        :loading="isLoading"
        color="primary"
        btn-width="32px"
        title="Download"
        offset-x
        :btn-type-text="false"
        :min-width="175"
        nudge-bottom="6px"
        rounded-menu="lg"
        :items="dropdownOptions"
      />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import DownloadIcon from '@/assets/img/icons/download/download-with-circle.svg';
import { useOrganizationStore } from '@/store/modules/useOrganizationStore';
import { Party } from '@/types/organization/partners/response';

export default defineComponent({
  name: 'ExportInventory',
  components: {
    ReportWrapper,
    CustomerAutocomplete: () =>
      import('@/components/autocomplete/CustomerAutocompleteComponent.vue'),
  },
  setup() {
    const selectedCustomer = ref<Party | null>(null);

    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();
    const organizationStore = useOrganizationStore();

    const download = async (outputType: string) => {
      try {
        const { data } = await downloadReport({
          customer: selectedCustomer.value?.accountNumber ?? '',
          customerName: selectedCustomer.value?.accountName ?? '',
          documentType: DocumentTypes.EXPORT_INVENTORY,
          outputType,
        });

        if (!data) return;

        downloadFileByType(data, `Export Inventory Report ${date(new Date(), "YYYY-MM-DD")} ${organizationStore.currentWarehouse?.code}`, outputType);
      } catch (error) {
        console.log(error);
      }
    };

    const dropdownOptions = [
      {
        title: 'Download XLSX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.XLSX),
      },
      {
        title: 'Download PDF',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.PDF),
      },
      {
        title: 'Download DOCX',
        icon: DownloadIcon,
        iconWidth: 20,
        handler: () => download(OutputTypes.DOCX),
      },
    ];

    return {
      selectedCustomer,
      isLoading,
      dropdownOptions,
    };
  },
});
</script>
